import axios, { AxiosResponse } from 'axios'
import { CryptoUtilities } from 'securedrive-crypto'
import { UploadRequestResponse } from '../../types'
import { getEncryptionKeys, RequestOptions } from '../request/RequestHelpers'
import { RequestService } from '../request/RequestService'
import { SessionService } from '../session/session.service'
import { OperationSpec } from '../transactions/models/OperationContext'
import { getParameters } from './FilesService'

export class FileUploadService {
  onProgressUpdate?: (progress: number) => void
  private abortController: AbortController | null = null

  constructor() {
    this.abortController = new AbortController()
  }

  async uploadFile(
    options: OperationSpec,
    signal?: AbortSignal
  ): Promise<UploadRequestResponse> {
    const { path, isEncryptedZone = false, from } = options
    const file = options.file as File
    if (!file) {
      throw new Error('File non presente')
    }

    let md5 = await CryptoUtilities.computeMD5(file)

    let fileToUpload: any = file
    let extraRequestOptions: Partial<RequestOptions> | undefined = undefined

    if (isEncryptedZone) {
      const { encryptedFile, requestOptions } = await getEncryptionKeys(options)
      fileToUpload = encryptedFile
      extraRequestOptions = requestOptions
      md5 = requestOptions.content_md5!

      console.log(
        '🚀 ~ FileUploadService ~ extraRequestOptions:',
        extraRequestOptions
      )
    }

    const declaredRequest =
      await RequestService.makeRequest<UploadRequestResponse>(
        options,
        extraRequestOptions,
        signal
      )

    const { basis } = await SessionService.getBasis()
    console.log('Basis:', basis)

    await this.performUpload(declaredRequest, fileToUpload, md5, signal)
    return declaredRequest
  }

  public async getMd5(file: File): Promise<string> {
    const md5 = await CryptoUtilities.computeMD5(file)
    return md5
  }

  public getMimeType(filename: string): string {
    // Implementazione semplificata, da espandere con una mappatura più completa
    const ext = filename.split('.').pop()?.toLowerCase()
    switch (ext) {
      case 'txt':
        return 'text/plain'
      case 'pdf':
        return 'application/pdf'
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg'
      case 'png':
        return 'image/png'
      default:
        return 'application/octet-stream'
    }
  }

  private async performUpload(
    uploadRequest: UploadRequestResponse,
    fileToUpload: File,
    contentMD5: string,
    signal?: AbortSignal
  ): Promise<AxiosResponse> {
    const { upload_url, requestOptions } = uploadRequest

    const parameters = await getParameters()
    console.log('Parameters:', parameters)

    const contentMd5 = await CryptoUtilities.fromHexToBase64(contentMD5)
    console.log('🚀 ~ FileUploadService ~ contentMd5:', contentMd5)

    const headers: any = {
      accept: '*/*',
      'content-md5': contentMd5,
      'content-type': fileToUpload.type,
    }

    if (requestOptions.encryption_iv) {
      headers[parameters.storage.metadata_prefix + 'encryption-iv'] =
        requestOptions.encryption_iv
    }
    if (requestOptions.encryption_dek) {
      headers[parameters.storage.metadata_prefix + 'encryption-dek'] =
        requestOptions.encryption_dek
    }

    return axios.put(upload_url, fileToUpload, {
      headers: headers,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total!
        )
        console.log(`Upload progress: ${percentCompleted}%`)
        if (this.onProgressUpdate) {
          this.onProgressUpdate(percentCompleted)
        }
      },
      signal: signal, // Aggiungi il segnale di abort
    })
  }

  abortUpload(): void {
    if (this.abortController) {
      this.abortController.abort()
    }
  }
}
export default FileUploadService
